import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import NewOrder from "@/pages/admin/NewOrder";
import OrderDetail from "@/pages/admin/OrderDetail";
import Drivers from "@/pages/admin/Drivers";
import DriverLayout from "@/pages/driver/DriverLayout";
import DriverHome from "@/pages/driver/DriverHome";
import DriverOrder from "@/pages/driver/DriverOrder";

const Splash = () => (
  <div className="flex min-h-screen items-center justify-center" data-testid="app-loading">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
  </div>
);

const homeFor = (user) => (user.role === "admin" ? "/admin" : "/driver");

function Protected({ role, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
}

function App() {
  return (
    <div className="App grain min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Protected role="admin"><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="orders/new" element={<NewOrder />} />
              <Route path="orders/:id" element={<OrderDetail />} />
              <Route path="drivers" element={<Drivers />} />
            </Route>
            <Route path="/driver" element={<Protected role="driver"><DriverLayout /></Protected>}>
              <Route index element={<DriverHome />} />
              <Route path="orders/:id" element={<DriverOrder />} />
            </Route>
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
